var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v(" "+_vm._s(_vm.$t('Purchase installments'))+" ")]),(_vm.$parent.item.stat == 1 && _vm.$checkRole('purchase_installments_add'))?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"title":_vm.$t('Add premium'),"to":'/purchaseInstallments/create?supplier_id=' + _vm.$route.params.id}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('Addition'))+" ")]):_vm._e()],1),_c('indexTable',{attrs:{"searchText":_vm.$t('Search for premium'),"withoutCard":true,"emptyTableText":_vm.$t('There are no purchase cheques'),"filter":{ supplier_id: _vm.$route.params.id },"emptyTableSubText":_vm.$t('Try adding some items to the table and try again'),"cloumns":[
        {
          column: 'code',
          title: _vm.$t('Paid'),
          type: 'mainLink',
          sort: true
        },
        {
          column: 'supplier_id',
          title: _vm.$t('Supplier name'),
          type: 'link',
          to: 'supplier',
          sort: true,
          link: true
        },
        {
          column: 'created_date',
          title: _vm.$t('Date Registration'),
          type: 'text',
          sort: true
        },
        {
          column: 'date',
          title: _vm.$t('Payment date'),
          type: 'text',
          sort: true
        },
        {
          column: 'description',
          title: _vm.$t('Thats about'),
          type: 'text',
          sort: true
        },
        {
          column: 'cost',
          title: _vm.$t('Amount'),
          type: 'text',
          sort: true
        },
        {
          column: 'payment_method_id',
          title: _vm.$t('Payment method'),
          type: 'link',
          to: 'paymentMethod',
          sort: true,
          link: false
        },
        {
          column: 'stat',
          title: _vm.$t('The condition'),
          type: 'status',
          sort: true,
          values: [
            {
              title: _vm.$t('Pending'),
              value: 0,
              color: 'info'
            },
            {
              title: _vm.$t('Driven'),
              value: 1,
              color: 'success'
            }
          ]
        },
        {
          column: 'options',
          title: _vm.$t('Settings'),
          type: 'options',
          options: [
            { name: 'show' },
            {
              name: 'edit',
              role: _vm.$checkRole('purchase_cheques_edit')
            },
            {
              name: 'pay',
              role: _vm.$checkRole('purchase_cheques_edit')
            },
            {
              name: 'delete',
              role: _vm.$checkRole('purchase_cheques_delete')
            }
          ]
        }
      ],"deleteText":{
        attention: _vm.$t('Attention'),
        areYouReallySureToDeleteTheItem: _vm.$t('Are you really sure to delete the item'),
        close: _vm.$t('Close'),
        confirm: _vm.$t('Confirm'),
        loading: _vm.$t('Loading')
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }